export default {"src":"/_next/static/media/bannerBuyback.71fb1164.gif","height":472,"width":2462};